// Constants
const RESOLUTION = 0.05

// Helpers
const noise = toxi.math.noise.simplexNoise.noise
const scale = (num, inMin, inMax, outMin, outMax) =>
	((num - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin
const calcPoints1 = (angle, blob, mutation, c) => {
	let mMod = blob.movementModifier
	let lDim = c.width > c.height ? c.width : c.height
	let xOff = scale(Math.cos(angle), -1 * mMod, mMod, 0, mMod)
	let yOff = scale(Math.sin(angle), -1 * mMod, mMod, 0, mMod)
	let R = scale(
		noise(xOff, yOff, mutation),
		-1 * mMod,
		mMod,
		lDim * blob.radius_small,
		lDim * blob.radius_large
	)

	return {
		x: Math.cos(angle) * R,
		y: Math.sin(angle) * R,
	}
}
const calcPoints2 = (angle, blob, mutation, c) => {
	let mMod = blob.movementModifier
	let lDim = c.width > c.height ? c.width : c.height
	let xOff = scale(Math.sin(angle), -1 * mMod, mMod, 0, mMod)
	let yOff = scale(Math.cos(angle), -1 * mMod, mMod, 0, mMod)
	let R = scale(
		noise(xOff, yOff, mutation),
		-1 * mMod,
		mMod,
		lDim * blob.radius_small,
		lDim * blob.radius_large
	)

	return {
		x: Math.cos(angle) * R,
		y: Math.sin(angle) * R,
	}
}
const createBlob = (
	radius,
	color,
	centerX,
	centerY,
	movementModifier,
	radiusModifier = 1
) => {
	return {
		radius,
		mutation_rate: RESOLUTION * 0.0001,
		radius_large: radius * 1.5 * radiusModifier,
		radius_small: radius * 0.25,
		color,
		centerX,
		centerY,
		movementModifier,
	}
}
const resize = c => {
	c.width = c.parentElement.getBoundingClientRect().width
	c.height = c.parentElement.getBoundingClientRect().height
}

const bgType1 = element => {
	// Set up blobs as objects
	let blobs = []
	const createBlobs = () => {
		blobs.push(createBlob(0.35, 'rgba(235, 77, 90, 0.5)', 0.5, 1.2, 8))
		blobs.push(createBlob(0.3, 'rgba(237, 62, 38, 0.5)', 0.1, 1.1, 3))
		blobs.push(createBlob(0.2, 'rgba(237, 62, 38, 0.5)', 0.55, -0.1, 12))
		blobs.push(createBlob(0.35, 'rgba(235, 177, 190, 0.1)', 0.1, -0.2, 10))
		blobs.push(createBlob(0.2, 'rgba(235, 227, 240, 0.2)', 0.1, -0.1, 2))
		blobs.push(createBlob(0.07, 'rgba(245, 145, 95, 0.8)', 0.05, 0.5, 1.5))
		blobs.push(createBlob(0.07, 'rgba(235, 77, 90, 0.5)', 0, 0.4, 3))
		blobs.push(createBlob(0.1, 'rgba(245, 145, 95, 0.8)', 0.45, 0.6, 1, 1.5))
		blobs.push(createBlob(0.1, 'rgba(245, 145, 95, 0.7)', 0.6, 0.5, 1.5))
		blobs.push(createBlob(0.07, 'rgba(245, 145, 95, 0.7)', 0.7, 0.6, 1))
		blobs.push(createBlob(0.1, 'rgba(245, 87, 68, 0.7)', 0.35, 0.4, 3))
		blobs.push(createBlob(0.14, 'rgba(245, 87, 68, 0.5)', 0.45, 0.6, 2))
		blobs.push(createBlob(0.2, 'rgba(239, 111, 71, 0.8)', 0.9, 1, 2))
		blobs.push(createBlob(0.3, 'rgba(235, 77, 90, 0.7)', 0.95, 0, 3))
		blobs.push(createBlob(0.14, 'rgba(235, 77, 90, 0.4)', 0.9, 0.7, 4))
	}
	createBlobs()

	// Actually do the canvas stuff
	const c = element.querySelector('canvas')
	const ctx = c.getContext('2d')

	let mutation = 0
	const loop = () => {
		ctx.save()
		ctx.clearRect(0, 0, c.width, c.height)
		ctx.fillStyle = '#F55744'
		ctx.fillRect(0, 0, c.width, c.height)

		blobs.forEach(blob => {
			let { x, y } = calcPoints1(0, blob, mutation, c)
			mutation += blob.mutation_rate
			ctx.setTransform(1, 0, 0, 1, 0, 0)
			ctx.translate(c.width * blob.centerX, c.height * blob.centerY)

			ctx.beginPath()
			ctx.moveTo(x, y)

			for (let angle = 0; angle < Math.PI * 2; angle += RESOLUTION) {
				let { x, y } = calcPoints1(angle, blob, mutation, c)
				ctx.lineTo(x, y)

				angle += RESOLUTION
				mutation += blob.mutation_rate
			}

			ctx.closePath()
			ctx.fillStyle = blob.color
			ctx.strokeStyle = blob.color
			ctx.fill()
			ctx.stroke()
		})

		ctx.restore()
		window.requestAnimationFrame(loop)
	}
	loop()
}

const bgType2 = element => {
	// Set up blobs as objects
	let blobs = []
	const createBlobs = () => {
		blobs.push(createBlob(0.45, 'rgba(235, 77, 90, 0.5)', 0.5, 1.2, 8))
		blobs.push(createBlob(0.4, 'rgba(237, 62, 38, 0.5)', 0.1, 1.1, 3))
		blobs.push(createBlob(0.3, 'rgba(235, 227, 240, 0.2)', 0.9, -0.1, 2))
		blobs.push(createBlob(0.17, 'rgba(239, 111, 71, 0.5)', 0, 0.6, 3))
		blobs.push(createBlob(0.2, 'rgba(245, 145, 95, 0.8)', 0.35, 0.4, 1, 1.5))
		blobs.push(createBlob(0.17, 'rgba(245, 145, 95, 0.7)', 0.65, 0.3, 2))
		blobs.push(createBlob(0.3, 'rgba(237, 62, 38, 0.5)', 0.1, 0, 6))
		blobs.push(createBlob(0.2, 'rgba(245, 87, 68, 0.5)', 0.5, 0.65, 3))
		blobs.push(createBlob(0.3, 'rgba(239, 111, 71, 0.8)', 1, 0.6, 2))
		blobs.push(createBlob(0.4, 'rgba(235, 77, 90, 0.7)', 0.55, -0.2, 5))
		blobs.push(createBlob(0.24, 'rgba(235, 77, 90, 0.4)', 0.9, 0.9, 4))
	}
	createBlobs()

	// Actually do the canvas stuff
	const c = element.querySelector('canvas')
	const ctx = c.getContext('2d')

	let mutation = 0
	const loop = () => {
		ctx.save()
		ctx.clearRect(0, 0, c.width, c.height)
		ctx.fillStyle = '#F55744'
		ctx.fillRect(0, 0, c.width, c.height)

		blobs.forEach(blob => {
			let { x, y } = calcPoints2(0, blob, mutation, c)
			mutation += blob.mutation_rate
			ctx.setTransform(1, 0, 0, 1, 0, 0)
			ctx.translate(c.width * blob.centerX, c.height * blob.centerY)

			ctx.beginPath()
			ctx.moveTo(x, y)

			for (let angle = 0; angle < Math.PI * 2; angle += RESOLUTION) {
				let { x, y } = calcPoints2(angle, blob, mutation, c)
				ctx.lineTo(x, y)

				angle += RESOLUTION
				mutation += blob.mutation_rate
			}

			ctx.closePath()
			ctx.fillStyle = blob.color
			ctx.strokeStyle = blob.color
			ctx.fill()
			ctx.stroke()
		})

		ctx.restore()
		window.requestAnimationFrame(loop)
	}
	loop()
}

const bgType3 = element => {
	// Set up blobs as objects
	let blobs = []
	const createBlobs = () => {
		blobs.push(createBlob(0.45, 'rgba(235, 77, 90, 0.5)', 0.5, 1.2, 8))
		blobs.push(createBlob(0.4, 'rgba(235, 227, 240, 0.1)', 0.1, 1.1, 3))
		blobs.push(createBlob(0.17, 'rgba(245, 145, 95, 0.5)', 0, 0.6, 3))
		blobs.push(createBlob(0.2, 'rgba(235, 77, 90, 0.8)', 0.35, 0.4, 1.1, 1.5))
		blobs.push(createBlob(0.17, 'rgba(245, 145, 95, 0.8)', 0.65, 0.3, 2))
		blobs.push(createBlob(0.2, 'rgba(245, 87, 68, 0.5)', 0.5, 0.65, 3))
		blobs.push(createBlob(0.3, 'rgba(239, 111, 71, 0.8)', 1, 0.6, 2))
		blobs.push(createBlob(0.3, 'rgba(245, 145, 95, 0.9)', 0.55, -0.2, 1.2))
		blobs.push(createBlob(0.24, 'rgba(237, 62, 38, 0.4)', 0.9, 0.9, 4))
		blobs.push(createBlob(0.3, 'rgba(237, 62, 38, 0.5)', 0.1, 0, 6))
		blobs.push(createBlob(0.3, 'rgba(235, 227, 240, 0.2)', 0.9, -0.1, 2))
	}
	createBlobs()

	// Actually do the canvas stuff
	const c = element.querySelector('canvas')
	const ctx = c.getContext('2d')

	let mutation = 0
	const loop = () => {
		ctx.save()
		ctx.clearRect(0, 0, c.width, c.height)
		ctx.fillStyle = '#F55744'
		ctx.fillRect(0, 0, c.width, c.height)

		blobs.forEach(blob => {
			let { x, y } = calcPoints2(0, blob, mutation, c)
			mutation += blob.mutation_rate
			ctx.setTransform(1, 0, 0, 1, 0, 0)
			ctx.translate(c.width * blob.centerX, c.height * blob.centerY)

			ctx.beginPath()
			ctx.moveTo(x, y)

			for (let angle = 0; angle < Math.PI * 2; angle += RESOLUTION) {
				let { x, y } = calcPoints2(angle, blob, mutation, c)
				ctx.lineTo(x, y)

				angle += RESOLUTION
				mutation += blob.mutation_rate
			}

			ctx.closePath()
			ctx.fillStyle = blob.color
			ctx.strokeStyle = blob.color
			ctx.fill()
			ctx.stroke()
		})

		ctx.restore()
		window.requestAnimationFrame(loop)
	}
	loop()
}

const bgType4 = element => {
	// Set up blobs as objects
	let blobs = []
	const createBlobs = () => {
		blobs.push(createBlob(0.45, 'rgba(235, 77, 90, 0.5)', 0.5, 1.2, 8))
		blobs.push(createBlob(0.4, 'rgba(237, 62, 38, 0.5)', 0.1, 1.1, 3))
		blobs.push(createBlob(0.3, 'rgba(235, 227, 240, 0.2)', 0.9, -0.1, 2))
		blobs.push(createBlob(0.17, 'rgba(239, 111, 71, 0.5)', 0, 0.6, 3))
		blobs.push(createBlob(0.2, 'rgba(245, 145, 95, 0.8)', 0.35, 0.4, 1, 1.5))
		blobs.push(createBlob(0.17, 'rgba(245, 145, 95, 0.7)', 0.65, 0.3, 2))
		blobs.push(createBlob(0.3, 'rgba(237, 62, 38, 0.5)', 0.1, 0, 6))
		blobs.push(createBlob(0.2, 'rgba(245, 87, 68, 0.5)', 0.5, 0.65, 3))
		blobs.push(createBlob(0.3, 'rgba(239, 111, 71, 0.8)', 1, 0.6, 2))
		blobs.push(createBlob(0.4, 'rgba(235, 77, 90, 0.7)', 0.55, -0.2, 5))
		blobs.push(createBlob(0.24, 'rgba(235, 77, 90, 0.4)', 0.9, 0.9, 4))
	}
	createBlobs()

	// Actually do the canvas stuff
	const c = element.querySelector('canvas')
	const ctx = c.getContext('2d')

	let mutation = 0
	const loop = () => {
		ctx.save()
		ctx.clearRect(0, 0, c.width, c.height)
		ctx.fillStyle = '#F55744'
		ctx.fillRect(0, 0, c.width, c.height)

		blobs.forEach(blob => {
			let { x, y } = calcPoints1(0, blob, mutation, c)
			mutation += blob.mutation_rate
			ctx.setTransform(1, 0, 0, 1, 0, 0)
			ctx.translate(c.width * blob.centerX, c.height * blob.centerY)

			ctx.beginPath()
			ctx.moveTo(x, y)

			for (let angle = 0; angle < Math.PI * 2; angle += RESOLUTION) {
				let { x, y } = calcPoints1(angle, blob, mutation, c)
				ctx.lineTo(x, y)

				angle += RESOLUTION
				mutation += blob.mutation_rate
			}

			ctx.closePath()
			ctx.fillStyle = blob.color
			ctx.strokeStyle = blob.color
			ctx.fill()
			ctx.stroke()
		})

		ctx.restore()
		window.requestAnimationFrame(loop)
	}
	loop()
}

let type1Sections = document.querySelectorAll(
	'section.hero.moving-color-bg, section.archive-hero, section.single-hero'
)
type1Sections.forEach(section => {
	bgType1(section)
})

let type2Sections = document.querySelectorAll(
	'section.text-w-image-card, section.hero.image, section.hero.contact, section.contact'
)
type2Sections.forEach(section => {
	bgType2(section)
})

let cards = document.querySelectorAll('section.cards .card .bg-element')
cards.forEach((card, index) => {
	if (index % 3 == 0) {
		bgType3(card)
	} else if (index % 3 == 1) {
		bgType1(card)
	} else {
		bgType2(card)
	}
})

let type4Sections = document.querySelectorAll('section.featured-posts')
type4Sections.forEach(section => {
	bgType4(section)
})

let allCanvases = document.querySelectorAll('canvas')
allCanvases.forEach(canvas => {
	resize(canvas)
})
window.addEventListener('resize', () => {
	allCanvases.forEach(canvas => {
		resize(canvas)
	})
})
